import HSPinInput from "@preline/pin-input";
import { forwardRef, type PropsWithChildren, useEffect, useRef } from "react";

import { cn } from "$/lib/utils/functions/misc.functions";

import type { PinInputProps } from "./PinInput.types";

const PinInput = forwardRef<HTMLDivElement, PropsWithChildren<PinInputProps>>(
  ({ disabled, error, onChange }, forwardedRef) => {
    const instance = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
      HSPinInput.autoInit();

      const pinInput = new HSPinInput(instance.current!);

      if (!pinInput) return;

      pinInput.on(
        "completed",
        ({ currentValue }: { currentValue: string[] }) => {
          onChange(currentValue.join(""));
        },
      );
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
      <div ref={forwardedRef} className="flex flex-col gap-2">
        <div
          ref={instance}
          className="flex items-center gap-x-3"
          data-hs-pin-input=""
        >
          {Array.from({ length: 3 }).map((_, index) => (
            <input
              key={index}
              type="text"
              className={cn(
                "bg-snow block w-[38px] rounded-md border-gray-300 text-center text-sm font-semibold text-black focus:border-primary focus:ring-primary disabled:pointer-events-none disabled:opacity-50",
                {
                  "border-danger focus:border-danger focus:ring-danger": error,
                },
              )}
              data-hs-pin-input-item=""
              disabled={disabled}
            />
          ))}

          <span className="h-1.5 w-1.5 rounded-full bg-primary" />

          {Array.from({ length: 3 }).map((_, index) => (
            <input
              key={index + 3}
              type="text"
              className={cn(
                "bg-snow block w-[38px] rounded-md border-gray-300 text-center text-sm font-semibold text-black focus:border-primary focus:ring-primary disabled:pointer-events-none disabled:opacity-50",
                {
                  "border-danger focus:border-danger focus:ring-danger": error,
                },
              )}
              data-hs-pin-input-item=""
              disabled={disabled}
            />
          ))}
        </div>

        {error && <div className="mt-1 text-sm text-danger">Invalid pin</div>}
      </div>
    );
  },
);

PinInput.displayName = "PinInput";

export default PinInput;
